<!--Recommended products-->
<template>
  <div v-if="quiktip.bu_id">
    <h3 class="mb-5">Recommended products</h3>
    <div class="h4 mb-5">
      關聯的產品(最多4筆, 排序同Product Listing Page)
      <button
        v-if="!quiktip.products || quiktip.products.length < 4"
        class="btn btn-primary w-90px ml-5"
        @click="addCategory">新增產品
      </button>
      <button v-else class="btn btn-primary w-90px ml-5" disabled>
        新增
      </button>
    </div>
    <!-- items -->
    <PageCollapse v-for="(item, i) in quiktip.products" :key="i">
      <template v-slot:head>
        <h3 class="mr-auto">Product {{ i + 1 }}</h3>
      </template>
      <template v-slot:actions>
        <div class="ml-auto">
          <button class="btn square mr-10px" @click="deleteItem(item)">
            <v-icon class="ink-02-medium--text">delete</v-icon>
          </button>
        </div>
      </template>
      <template v-slot:body>
        <!-- BU -->
        <div class="form-item d-flex py-5">
          <div class="w-240px mr-5"><h4>Bu</h4></div>
          <div class="flex-grow-1 flew-basis-0 my-n2">
            <div class="w-248px mr-5 quiktips-autocomplete">
              <v-autocomplete
                v-model="item.bu_id"
                :items="filteredBuTabs"
                placeholder="請選擇所屬BU"
                class="w-240px"
                item-text="name"
                item-value="id"
                outlined
                dense
                @change="onBuChange(item, i)"
              >
              </v-autocomplete>
            </div>
          </div>
        </div>
        <!-- 選擇分類 -->
        <div class="form-item d-flex py-5">
          <div class="w-240px mr-5"><h4>Category</h4></div>
          <div class="flex-grow-1 flew-basis-0 my-n2">
            <div class="w-248px mr-5 quiktips-autocomplete">
              <v-autocomplete
                :items="item.categories"
                v-model="item.product_category_id"
                placeholder="請選擇分類"
                item-value="id"
                item-text="name"
                outlined
                dense
                @change="onCategoryChange(item, i)"
              >
              </v-autocomplete>
            </div>
          </div>
        </div>
        <!-- Model Name -->
        <div class="form-item d-flex py-5">
          <div class="w-240px mr-5"><h4>Model Name</h4></div>
          <div class="flex-grow-1 flew-basis-0 my-n2">
            <div class="w-480px mr-5 quiktips-autocomplete">
              <v-autocomplete
                v-model="item.product_ids"
                :items="item.products"
                placeholder="請選擇產品"
                item-text="product_with_subcategory"
                item-value="id"
                outlined
                dense
                @change="onProductChange(item, i)"
                :error-messages="item.buErrors"
              >
              </v-autocomplete>
            </div>
          </div>
        </div>
      </template>
    </PageCollapse>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import PageCollapse from '@/components/PageCollapse.vue';

export default {
  components: {
    PageCollapse,
  },
  data: () => ({
    prodError: '',
  }),
  props: {
    quiktip: {
      type: Object,
      default: () => ({
        products: [],
      }),
    },
  },
  computed: {
    ...mapState(['buTabs']),
    filteredBuTabs() {
      const excludeIds = [4, 5];
      return this.buTabs.filter((bu) => !excludeIds.includes(bu.id));
    },
  },
  methods: {
    ...mapActions('category', ['allByBu', 'allByCategory']),
    selectCategory(id, categoryId) {
      const category = this.quiktip.products[id].categories.find((item) => item.id === categoryId);
      if (category) {
        return category.products;
      }
      return [];
    },
    addCategory() {
      if (!this.quiktip.products) {
        this.$set(this.quiktip, 'products', []);
      }
      const template = {
        bu_id: '',
        product_category_id: '',
        product_ids: [],
        categories: [], // Default empty categories
        buErrors: '',
        products: [],
      };
      this.quiktip.products.push(template);
    },
    deleteItem(item) {
      const index = this.quiktip.products.map((i) => i.id).indexOf(item.id);
      this.quiktip.products.splice(index, 1);
    },
    async loadCategoriesByBu(buId, itemIndex) {
      try {
        if (buId) {
          const categories = await this.allByBu(buId);
          this.$set(this.quiktip.products[itemIndex], 'categories', categories);
        }
      } catch (error) {
        // console.error('Error loading categories:', error);
      }
    },
    async loadProductsByCategory(categoryId, itemIndex) {
      try {
        if (categoryId) {
          const products = await this.selectCategory(itemIndex, categoryId);
          this.$set(this.quiktip.products[itemIndex], 'products', products);
        }
      } catch (error) {
        // console.error('Error loading products:', error);
      }
    },
    // Handle BU change
    onBuChange(item, index) {
      this.loadCategoriesByBu(item.bu_id, index);
    },
    // Handle Category change
    onCategoryChange(item, index) {
      this.loadProductsByCategory(item.product_category_id, index);
    },
    // Handle Product change
    onProductChange(item, index) {
      this.quiktip.products.forEach((prod, idx) => {
        if (prod.product_ids === item.product_ids && index !== idx) {
          this.prodError = 'Product IDs are duplicate';
        } else if (prod.product_ids !== item.product_ids && prod.buErrors) {
          this.prodError = '';
        }
      });
      this.quiktip.products[index].buErrors = this.prodError;
    },
  },
  watch: {
    // 監視 quiktip.products 中每個 item.bu_id 的變化
    'quiktip.products': {
      handler(newProducts) {
        if (Array.isArray(newProducts)) {
          newProducts.forEach((item, index) => {
            if (item.bu_id) {
              this.loadCategoriesByBu(item.bu_id, index);
            }
            if (item.product_category_id) {
              this.loadProductsByCategory(item.product_category_id, index);
            }
          });
        } else {
          // console.warn('quiktip.products is not an array or is undefined.');
        }
      },
      immediate: true, // 在初始化時也會觸發一次
    },
  },
};
</script>
<style lang="scss">
// v-autocomplete
.quiktips-autocomplete {
  .v-autocomplete {
    .v-input__slot {
      border-top-left-radius: 0px;
      border-bottom-left-radius: 0px;
    }
    .v-text-field__details {
      display: none;
    }
  }
}
</style>
